import axios from "axios";
import { SERVICEURL } from "../appconfig";

export const getSalaryExpectationDetail = async (id: string) => {
  try {
    const token = localStorage.getItem("token");
    const headers = token
      ? {
          Authorization: `Bearer ${token}`,
        }
      : undefined;

    const response = await axios.get(
      `${SERVICEURL}api/Candidates/GetSalaryExpectationDetail/${id}`,
      { headers }
    );

    const data = response.data?.data || response.data;

    if (!data) {
      throw new Error("No data returned from API");
    }

    const findField = (obj: any, fieldName: string) => {
      const key = Object.keys(obj).find(
        (k) => k.toLowerCase() === fieldName.toLowerCase()
      );
      return key ? obj[key] : undefined;
    };

    return {
      id: findField(data, "id") || findField(data, "ID"),
      salaryExpectation: findField(data, "salaryExpectation"),
      exchangeParameterId: findField(data, "exchangeParameterId"),
      totalExperienceYear: findField(data, "totalExperienceYear"),
      totalExperienceMonth: findField(data, "totalExperienceMonth"),
      enteringMemberId: findField(data, "enteringMemberId"),
      isBilling: findField(data, "isBilling"),
      noticeTime: findField(data, "noticeTime"),
      createDate: data.createDate,
    };
  } catch (error) {
    console.error("Get Salary Expectation Detail Error:", error);
    throw error;
  }
};

export const updateSalaryExpectation = async (payload: {
  id: string;
  salaryExpectation: number;
  exchangeParameterId?: string;
  totalExperienceYear: number;
  totalExperienceMonth: number;
  enteringMemberId?: string | null;
  isBilling: boolean;
  noticeTime: string;
}) => {
  try {
    const token = localStorage.getItem("token");
    const headers = token
      ? {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      : { "Content-Type": "application/json" };

    const response = await axios.put(
      `${SERVICEURL}api/Candidates/UpdateSalaryAndNoticeInfo`,
      payload,
      { headers }
    );

    return response.data;
  } catch (error) {
    console.error("Update Salary Expectation Error:", error);
    throw error;
  }
};

export const deleteSalaryExpectation = async (
  salaryExpectationId: string
): Promise<void> => {
  const token = localStorage.getItem("token");
  await axios.delete(
    `${SERVICEURL}api/Candidates/DeleteSalaryExpectationInfo/${salaryExpectationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
